import { useCallback, useEffect, useState } from 'react';
import { useT } from '../../i18n';
import { api } from '../../api/client';

interface RecentProject { id: number; name: string; project_code: string | null }

/**
 * Sidebar section: the last 3 projects this user opened, newest first — one
 * click back to a project's Aperçu. Kept per user on the server (works on any
 * device); refreshed when a project is opened (pmo:recent-projects).
 */
export function RecentProjects({ currentProjectId }: { currentProjectId: number | null }) {
  const { t } = useT();
  const [items, setItems] = useState<RecentProject[]>([]);

  const load = useCallback(() => {
    api.getRecentProjects().then((rows) => setItems(rows as RecentProject[])).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    window.addEventListener('pmo:recent-projects', load);
    return () => window.removeEventListener('pmo:recent-projects', load);
  }, [load]);

  if (items.length === 0) return null;

  return (
    <div className="nav-section">
      <div className="nav-section-title">{t('shell.nav.recentProjects')}</div>
      {items.map((p) => (
        <a
          key={p.id}
          href={`#project?id=${p.id}`}
          className={`nav-link nav-recent${currentProjectId === p.id ? ' active' : ''}`}
          title={p.name}
        >
          {p.project_code && <span className="nav-recent-code">{p.project_code.toUpperCase()}</span>}
          <span className="nav-recent-name">{p.name}</span>
        </a>
      ))}
    </div>
  );
}
